"use strict";
'use client';
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 11.79 32", preserveAspectRatio: "xMidYMid meet", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "M11.713 7.829c.422-2.426-.965-3.684-2.412-3.815-1.89-.172-2.412 1.315-2.412 1.315L6.431 6.78l-.526-.17c0-.59-.118-1.061-.59-1.18-.472-.117-.944.237-1.18.945s-.078 1.387.394 1.505c.586.161 1.017-.256 1.253-.727l.489.136-1.188 3.766-.754-.243c0-.59-.118-1.061-.59-1.18-.472-.117-.944.237-1.18.944-.236.708-.077 1.388.395 1.506.586.161 1.016-.256 1.252-.728l.72.201-1.147 3.632-.662-.213c0-.59-.118-1.062-.59-1.18-.472-.118-.944.236-1.18.944s-.077 1.387.395 1.505c.585.162 1.016-.255 1.252-.727l.626.175-1.205 3.82-.537-.174c0-.59-.118-1.062-.59-1.18-.472-.118-.944.236-1.18.944s-.077 1.387.395 1.505c.585.162 1.016-.255 1.252-.727l.5.14-.277.877s-.41 1.257.482 1.71c1.467.746 1.294 2.081 1.294 2.081L3.688 28h5.043v-5.248c0-2.75 1.607-5.453 2.234-6.875.674-1.528.616-2.742.265-3.795-.35-1.052-.94-1.331-.789-1.973.176-.745 1.096-1.272 1.272-2.28zM3.87 21.05a.646.646 0 110-1.293.646.646 0 010 1.293zm1.446-4.372a.646.646 0 110-1.293.646.646 0 010 1.293zm1.304-4.326a.646.646 0 110-1.292.646.646 0 010 1.292zm1.421-4.351a.646.646 0 110-1.293.646.646 0 010 1.293z" })));
};
var SvgHeadstockUkuleleTeleFill = (0, styled_components_1.default)(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"], ["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'inline-block' : _b;
    return display;
}, function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? '32px' : _b;
    return fontSize;
});
exports.default = SvgHeadstockUkuleleTeleFill;
var templateObject_1;
